import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vmodal from 'vue-js-modal'
import VeeValidate from 'vee-validate';
import VueTheMask from 'vue-the-mask'
import vueTopprogress from 'vue-top-progress'
import {VueMasonryPlugin} from 'vue-masonry';
import VueMasonry from 'vue-masonry-css'
// import VueAnimateNumber from 'vue-animate-number'
// import VCalendar from 'v-calendar';
// import VueProgressBar from 'vue-progressbar'
import VueAwesomeSwiper from 'vue-awesome-swiper'
// import Vue2Crumbs from 'vue-2-crumbs'
import LoadScript from 'vue-plugin-load-script';
import firebaseConfig from './config/firebase'
import firebase from 'firebase'
import $ from 'jquery'

window.$ = window.jQuery = require('jquery');
window.axios = require('axios');
var ionRangeSlider = require('ion-rangeslider');
var infiniteScroll =  require('vue-infinite-scroll');
// var SocialSharing = require('vue-social-sharing');
var VueScrollTo = require('vue-scrollto');

// js libs
import 'bootstrap/dist/js/bootstrap.min.js'
import 'ion-rangeslider/js/ion.rangeSlider.min.js'
import './plugins/sharer.js'

import 'selectric/public/jquery.selectric.min.js'

// import './plugins/svgIcon.js'
// import '@/assets/icons'
// css libs
import 'swiper/dist/css/swiper.css'
import 'ion-rangeslider/css/ion.rangeSlider.min.css'

import 'selectric/public/themes/plus/selectric.css'
// import 'v-calendar/lib/v-calendar.min.css';
import 'vue-select/dist/vue-select.css';

window.body = $('body');
window.url = 'https://bcn.kz/cms/';
window.urlSales = 'https://sales.bazis.kz/cms/';
window.JsonUrl = 'wp-json/acf/v3/';
window.GlobalLang = localStorage.getItem('languageBCN');

if (window.GlobalLang === null) {
  window.GlobalLang = 'kz/';
  setDataLang(window.GlobalLang);
} else if (window.GlobalLang === 'ru') {
  window.GlobalLang = '';
  setDataLang(window.GlobalLang);
} else {
  setDataLang(window.GlobalLang);
}
function setDataLang(lang) {
  if (lang = '') {
    document.querySelector('body').dataset.language = window.GlobalLang;
  } else {
    document.querySelector('body').dataset.language = window.GlobalLang.replace(/\/$/, "");
  }
}

const configVeeValidate = {
  aria: true,
  classNames: {},
  classes: false,
  delay: 0,
  errorBagName: 'errors', // change if property conflicts
  events: 'input|blur',
  fieldsBagName: 'fields',
  i18n: null, // the vue-i18n plugin instance
  i18nRootKey: 'validations', // the nested key under which the validation messages will be located
  inject: true,
  locale: 'ru',
  validity: false
};

const configScrollTo = {
  container: "body",
  duration: 1200,
  easing: "ease-in-out",
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
};


firebase.initializeApp(firebaseConfig);

// Vue.use(Vue2Crumbs);
Vue.use(VueAwesomeSwiper);
Vue.use(VueTheMask);
Vue.use(VueMasonryPlugin);
Vue.use(VueMasonry);
Vue.use(infiniteScroll);
Vue.use(vmodal);
Vue.use(vueTopprogress);
// Vue.use(VueAnimateNumber);
Vue.use(LoadScript);

// Vue.use(SocialSharing);
Vue.use(VeeValidate, configVeeValidate);
Vue.use(VueScrollTo, configScrollTo);

new Vue({
  router,
  render: h => h(App),
  store,
  mounted: () => document.dispatchEvent(new Event("x-app-rendered"))
}).$mount('#app')